import React from 'react';
import './Press.css';

const pressItems = [
  {
    pub: 'San Diego Union Tribune',
    headline: '"What America Means to Me" — Alina Bokovikova',
    href: 'http://www.sandiegouniontribune.com/entertainment/theater/sdut-what-america-means-to-me-alina-bokovikova-2015jul04-htmlstory.html',
  },
  {
    pub: 'Fashion School Daily',
    headline: 'Behind the Magic: Alina Bokovikova\'s Dazzling Costume Designs Bring Panto Sleeping Beauty to Life',
    href: 'https://fashionschooldaily.com/behind-the-magic-alina-bokovikova-dazzling-costume-designs-panto-sleeping-beauty/73084/',
  },
  {
    pub: 'American Theatre',
    headline: '6 Theatre Workers You Should Know',
    href: 'https://www.americantheatre.org/2016/03/28/6-theatre-workers-you-should-know-5/',
  },
];

const Press = () => {
  return (
    <div className="press">
      <div className="section-inner">
        <div className="section-label">Recognition</div>
        <h2 className="section-title">In the <em>Press</em></h2>
        <div className="press-grid">
          {pressItems.map((item) => (
            <a
              key={item.pub}
              className="press-item"
              href={item.href}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="press-pub">{item.pub}</div>
              <div className="press-headline">{item.headline}</div>
              <div className="press-arrow">Read →</div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Press;